module.exports = __webpack_public_path__ + "../resources/img/ic_check.0451d8fe.svg";